import { render, staticRenderFns } from "./ProductSelecter.vue?vue&type=template&id=62627e1a&"
import script from "./ProductSelecter.vue?vue&type=script&lang=js&"
export * from "./ProductSelecter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports